"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const react_1 = __importDefault(require("react"));
const components_common_error_message_1 = require("@hotelplan/components.common.error-message");
const components_common_label_1 = __importDefault(require("@hotelplan/components.common.label"));
const RadioGroup_1 = __importDefault(require("./RadioGroup"));
const ValidatedRadioGroup = props => {
    const [field] = (0, formik_1.useField)({ name: props.name });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_common_label_1.default, { hideLabel: props.hideLabel },
            props.label,
            " ",
            props.required ? react_1.default.createElement("span", null, "*") : ''),
        react_1.default.createElement(RadioGroup_1.default, Object.assign({}, props, { value: field.value, onChange: (_, e) => field.onChange(e) })),
        react_1.default.createElement(components_common_error_message_1.ErrorMessage, { getMessage: message => message, error: props.error })));
};
exports.default = ValidatedRadioGroup;
//# sourceMappingURL=ValidatedRadioGroup.js.map